import { useEffect } from 'react';

import type { RealtimeUpdatePayload } from '@trello/realtime-updater';
import { realtimeUpdaterEvents } from '@trello/realtime-updater';

import { useConvertCardRoleButtonQuery } from './ConvertCardRoleButtonQuery.generated';

export function useRefetchConvertCardRoleButtonQuery(idCard: string): void {
  // eslint-disable-next-line @trello/no-apollo-refetch
  const { refetch } = useConvertCardRoleButtonQuery({
    variables: {
      idCard,
    },
    waitOn: ['PreloadCard'],
  });

  useEffect(() => {
    const realtimeUpdateHandler = (
      updatePayload: RealtimeUpdatePayload,
    ): void => {
      if (
        updatePayload.typeName === 'Card' &&
        updatePayload.deltas.find((d) => d.id === idCard)
      ) {
        refetch();
      }
    };

    realtimeUpdaterEvents.on('updateModels', realtimeUpdateHandler);

    return () => {
      realtimeUpdaterEvents.off('updateModels', realtimeUpdateHandler);
    };
  });
}
